import { createDatasetSlice, ResponseMapping } from 'src/redux/helpers';
import { pepApiRequest, RequestMethod } from 'src/services';
import { generatePath } from 'react-router-dom';
import {
  API_GET_SOLUTION_ALERT_PLATFORMCIDETAILS,
  SOLUTION_ALERT_PLATFORMCIDETAILS,
  SOLUTIONS_STORE,
} from '../constants';

const api = () =>
  pepApiRequest({
    method: RequestMethod.Get,
    url: API_GET_SOLUTION_ALERT_PLATFORMCIDETAILS,
  });

const platformCIDetails = createDatasetSlice({
  api,
  storeName: SOLUTIONS_STORE,
  actionName: SOLUTION_ALERT_PLATFORMCIDETAILS,
  responseMapping: ResponseMapping.Default,
});

export default platformCIDetails;
